var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bespoke-container view-container"},[_c('div',{staticClass:"bespoke-wrapper view-wrapper"},[_c('div',{staticClass:"bespoke-page page-wrapper"},[_c('banner-img',{attrs:{"imgSrc":_vm.bannerSrc,"text":_vm.bannerText}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }